exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-4890e068]{position:fixed;top:0;left:0;height:100vh;width:100%;background:rgba(0,0,0,.25);z-index:90002}.fade-enter-active[data-v-4890e068],.fade-leave-active[data-v-4890e068]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-4890e068],.fade-leave-to[data-v-4890e068]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4890e068","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/common/Overlay.vue
// module id = qBfa
// module chunks = 0 2